@let assistant = aiAssistantOrchestrator.assistantSg();

<div class="atn-detail-ai-banner__actions">
  <div class="atn-detail-ai-banner__buttons">
    <atn-ds-button
      type="transparent"
      class="atn-detail-ai-banner__button"
      (click)="summarizeHandler()"
    >
      <i class="atn-icon atn-comment atn-blue"></i>
      <span>Summarize</span>
    </atn-ds-button>

    <atn-ds-button
      type="transparent"
      class="atn-detail-ai-banner__button"
      (click)="guideHandler()"
    >
      <i class="atn-icon atn-information atn-blue"></i>
      <span>Interview Guide</span>
    </atn-ds-button>
  </div>

  @if (assistant) {
    @let aiMessages = assistant.selectors.messages.asSignal();
    @let hasAiMessages = aiMessages.length > 0;
    @let aiMessagesLoading = assistant.selectors.askIsSubmitting.asSignal();
    @let aiError = assistant.selectors.askErrorMessage.asSignal();

    @if (hasAiMessages || aiMessagesLoading) {
      <div class="atn-detail-ai-banner__results">
        <div class="atn-detail-ai-banner__results-header">
          <h4 class="atn-detail-ai-banner__results-title">AI Results</h4>
          <i
            class="atn-icon atn-close atn-dark atn-detail-ai-banner__results-close"
            (click)="
              assistant.actions.reset
                .from('Summit.Archive.Detail.Ai.Results.Close.Clicked')
                .dispatch()
            "
          ></i>
        </div>

        @if (aiMessagesLoading) {
          <div
            class="atn-detail-ai-banner__results-loading atn-detail-ai-banner__results-loading"
          >
            <div
              class="atn-detail-ai-banner__skeleton atn-detail-ai-banner__skeleton--ai-content"
            ></div>
            <div
              class="atn-detail-ai-banner__skeleton atn-detail-ai-banner__skeleton--ai-content"
            ></div>
            <div
              class="atn-detail-ai-banner__skeleton atn-detail-ai-banner__skeleton--ai-content"
            ></div>
          </div>
        } @else {
          <div class="atn-detail-ai-banner__results-content">
            @for (message of aiMessages; track $index) {
              @if (isMarkdownContent(message.content)) {
                <atn-markdown [data]="message.content" />
              } @else {
                <div
                  [innerHTML]="sanitizeMessageContent(message.content)"
                ></div>
              }
            } @empty {
              @if (aiError) {
                {{ aiError }}
              }
            }
          </div>
        }
      </div>
    }
  }
</div>
